import $ from 'jquery';
import { addToBagWithData } from "modules/add-to-bag";
import init from 'modules/heart-product'

$(function() {
    $('.js-revieve-full-look').on('click', (e) => {
        e.preventDefault();
        Revieve.API.show();
        logEngagement(window.location.href, 'VTO', 'Open');
    });

    $(window).on('revieveAddToBag', (e, data) => {
        data.products.forEach((product) => {
            addToBagWithData({
                colorSelect: product.id,
                sizeSelect: 'all',
                count: 1,
                sectionURL: data.sectionUrl,
                csrfHash: data.csrfHash,
            }, {
                success: (obj) => {
                    // start GA add to cart
                    gaAddToCartActionProduct('add', {
                        code: '' + product.id + '',
                        name: product.name,
                        category: obj.msg16,
                        brand: obj.msg3,
                        variant: 'all',
                        price: obj.msg15,
                        quantity: 1
                    });
                    // end GA add to cart

                    if (pushAddProductToCordial === 'function') {
                        pushAddProductToCordial(product.name,
                            product.id,
                            obj.msg15,
                            obj.msg3,
                            obj.msg16,
                            null,
                            obj.msg28,
                            1);
                    }

                    if (insertFacebookAddToCart === 'function') {
                        insertFacebookAddToCart(null, product.id, obj.msg15, 'all');
                    }

                    if (typeof addToCartPinterest === 'function') {
                        addToCartPinterest(product.id, obj.msg15, 1);
                    }

                    if (typeof addToCartReddit === 'function') {
                        const cartItems = [{
                            productCode: product.id,
                            productName: product.name,
                            productCategory: obj.msg16
                        }];
                        addToCartReddit(cartItems, obj.msg15, product.id, product.name, obj.msg16);
                    }
                    if(typeof spanglePixelAddToCart === 'function'){
                        spanglePixelAddToCart(product.id,obj.msg15,1);
                    }
                }
            });
        });
    });

    init('#main-content', '.js-favorite-button');
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/landing/index.js